<template>
    <div>
 <h3 id="wizard2-h-0" tabindex="-1" class="title current">{{step.title}}</h3>
<div v-if="step && step.subtitle && step.subtitle!=''">
  {{step.subtitle}}
</div>
        <div v-if="step && step.alert && step.alert!=''">
  {{step.alert}}
</div>    
        </div>
      
</template>

<script>
import axios from "axios";
export default {
  name: "stepheader",

  props: {
     step: {
      type: Object,
      required: true,
    },
    checkphone: {
      type: Boolean,
      required: false,
       default: () => true,
    },
     ticket: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      templates: [],
      wizard: {},
      usersteps: [],
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
  
  },
  methods: {
  
  },
};
</script>